<template>
  <div>
    <el-breadcrumb separator="/" style="margin-bottom: 20px;">
      <el-breadcrumb-item el-breadcrumb-item :to="{ path: '/personal/batch' }">个人奖申报批次</el-breadcrumb-item>
      <el-breadcrumb-item el-breadcrumb-item :to="{ path: '/personal?batchId=' +  $route.query.batchId }">个人奖申报</el-breadcrumb-item>
      <el-breadcrumb-item>确认授奖</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-form :model="addForm" v-loading="loading" :rules="ruleAddForm" ref="addForm" label-width="180px" class="demo-ruleForm-zdy demo-ruleForms" size="small" >
        <el-form-item label="是否授奖" prop="isConfirm" >
          <el-radio-group v-model="addForm.isConfirm">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="联系方式" prop="phone" v-if="addForm.isConfirm == 1">
          <el-input style="width: 450px" maxlength="11" show-word-limit v-model.trim="addForm.phone" placeholder="请输入联系方式"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email" v-if="addForm.isConfirm == 1">
          <el-input style="width: 450px" maxlength="50" show-word-limit v-model.trim="addForm.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="身份证" prop="identityCard" v-if="addForm.isConfirm == 1">
          <el-input style="width: 450px" maxlength="18" show-word-limit v-model.trim="addForm.identityCard" placeholder="请输入身份证"></el-input>
        </el-form-item>
        <el-form-item label="放弃授奖证明(盖章扫描件 100MB)" prop="rejectAwardFileUrl" v-if="addForm.isConfirm == 2" key="rejectAwardFileUrl">
          <el-checkbox-group v-model="addForm.rejectAwardFileUrl" v-show="false"></el-checkbox-group>
          <My-Upload-Filebutton :limit="1" :size="100" @UploadFileFun="UploadFileFun($event, 'rejectAwardFileUrl')" :callbackShow="addForm.declarationFiles"></My-Upload-Filebutton>
        </el-form-item>

        <div style="margin: 80px 0 20px 180px; " v-if="status == 1">
          <!-- <el-button>取消</el-button> -->
          <el-button type="primary" @click="submit" :loading="addForm.loading">提 交</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
// getAwardconfirm
import MyUploadFilebutton from '@/components/uploadFilebutton/UploadFilebutton'
import { personalAwardconfirm, getProjectAwardBatchList, getPersonalAwardconfirm } from '@/api/admin'

export default {
  components: { MyUploadFilebutton },
  data () {
    return {
      status: '',
      id: '',
      flag: false,
      numUnit: '',
      numPeople: '',
      addForm: {
        id: '',
        loading: false,
        isConfirm: 1,
        identityCard: '',
        phone: '',
        email: '',
        rejectAwardFileUrl: ''
      },
      loading: false,
      ruleAddForm: {
        isConfirm: [{ required: true, message: '请选择是否授奖', trigger: 'change' }],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误', trigger: ['blur', 'change'] }
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        identityCard: [
          { required: true, message: '请输入身份证', trigger: 'blur' },
          { pattern: /^[1-9]\d{5}(18|19|([20]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '身份证号格式错误', trigger: ['blur', 'change'] }
        ],
        rejectAwardFileUrl: [{ required: true, message: '请上传文件', trigger: 'change' }]
      }
    }
  },
  created() {
    if (!this.$route.query.batchId) {
      this.$router.push({ path: '/personal/batch' })
      return false
    }
    this.loading = true
    getPersonalAwardconfirm({ id: this.$route.query.id }).then(res => {
      this.loading = false
      if (res.code == '000') {
        if (res.result) {
          this.addForm.identityCard = res.result.identityCard
          this.addForm.phone = res.result.phone
          this.addForm.email = res.result.email
          this.addForm.id = res.result.id
        }
      }
    })
    getProjectAwardBatchList({ page: 1, pageSize: 500 }).then(res => {
      if (res.code == '000') {
        const batchIds = res.result.records
        const exists = batchIds.some(item => item.id === this.$route.query.batchId)
        if (!exists) {
          this.$router.push({ path: '/personal/batch' })
        } else {
          batchIds.forEach(item => {
            if (item.id == this.$route.query.batchId) {
              this.status = item.status
            }
          })
        }
      }
    })
  },
  methods: {
    UploadFileFun(e, type) {
      this.addForm[type] = e
    },
    submit () {
      this.$refs.addForm.validate(valid => {
        if (!valid) return false
        this.$confirm('是否确定提交?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const parmas = {
            personalAwardId: this.$route.query.id,
            id: this.addForm.id,
            isConfirm: this.addForm.isConfirm,
            phone: this.addForm.isConfirm == 1 ? this.addForm.phone : '',
            email: this.addForm.isConfirm == 1 ? this.addForm.email : '',
            identityCard: this.addForm.isConfirm == 1 ? this.addForm.identityCard : '',
            rejectAwardFileUrl: this.addForm.isConfirm == 1 ? '' : this.addForm.rejectAwardFileUrl
          }
          this.addForm.loading = true
          personalAwardconfirm(parmas).then(res => {
            this.addForm.loading = false
            if (res.code === '000') {
              this.$message.success('操作成功')
              setTimeout(() => {
                this.$router.replace({ path: '/personal', query: { batchId: this.$route.query.batchId } })
              }, 500)
            }
          })
        })
      })
    }
  }
}
</script>

<style lang="less">
.demo-ruleForm-zdy {
  .el-form-item__content {
    line-height: 32px;
  }
  .el-form-item__label {
    line-height: 32px;
  }
}

</style>
